
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg,
    }
  })

  export default class ProductList extends Vue {
    private token:any = {}
    @Inject() information:any
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private uploadSuc1(list){
      this.editinfo.msg.coverimg = list[0]
    }
    private uploadSuc2(list){
      this.editinfo.msg.video = list[0]
    }
  }
